/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Compat_4Inputs */

const en_pc_online_compat_4 = /** @type {(inputs: Pc_Online_Compat_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phones and tablets can load it, but the layout is designed for desktop screens and keyboard shortcuts.`)
};

const zh_pc_online_compat_4 = /** @type {(inputs: Pc_Online_Compat_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手机和平板可以加载，但界面是为桌面屏幕和键盘快捷键设计的。`)
};

/**
* | output |
* | --- |
* | "Phones and tablets can load it, but the layout is designed for desktop screens and keyboard shortcuts." |
*
* @param {Pc_Online_Compat_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_compat_4 = /** @type {((inputs?: Pc_Online_Compat_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Compat_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_compat_4(inputs)
	return zh_pc_online_compat_4(inputs)
});
export { pc_online_compat_4 as "pc.online.compat.4" }